import { useState } from 'react'
import { useModalBrokerInvitation } from '../../useModalBrokerInvitation'

export const usePending = () => {
  const [step, setStep] = useState<1 | 2>(1)

  const { handleDeclined, isError, isLoading, isSuccessDeclined } =
    useModalBrokerInvitation()

  return {
    handleDeclined,
    isLoading,
    step,
    setStep,
    isSuccess: isSuccessDeclined,
    isError
  }
}
